import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import CodeOnboardingCard from './CodeOnboardingCard'
import LegacyPathCard from './LegacyPathCard'
import useFidelityMaximizer from './useFidelityMaximizer'
import { StyledOrDivider } from './styled-components'

const MODULE = 'subscriptionForm:fidelity_maximizer_module'

const FidelityMaximizer = () => {
  const {
    t,
    hidden,
    loyaltyBannerHidden,
    pdlWarningHidden,
    pdlOkBannerHidden,
    pdlOkBannerKey,
    codeCard,
    orDividerHidden,
    legacyCard,
    contactWarning,
  } = useFidelityMaximizer()

  if (hidden) {
    return null
  }

  return (
    <>
      <SDNotification
        hidden={loyaltyBannerHidden}
        type='positive'
        primaryText={`🏆 ${t(`${MODULE}.maximized_label`)}`}
      />

      <SDNotification hidden={pdlWarningHidden} type='warning' primaryText={t(`${MODULE}.pdl_missing_warning`)} />

      <SDNotification hidden={pdlOkBannerHidden} type='positive' primaryText={t(`${MODULE}.${pdlOkBannerKey}`)} />

      <CodeOnboardingCard {...codeCard} />

      <StyledOrDivider hidden={orDividerHidden}>{t(`${MODULE}.legacy_path.or`)}</StyledOrDivider>

      <LegacyPathCard {...legacyCard} />

      <SDNotification hidden={contactWarning.hidden} type='warning' primaryText={contactWarning.text} />
    </>
  )
}

export default FidelityMaximizer
